/* 🤖 this file was generated by script */
export const wiconPieChart01 = {
  name: 'pie_chart_01',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21.21 15.89A10 10 0 118 2.83m13.24 5.34a10 10 0 01.73 3.03c.02.26.03.39-.02.5a.52.52 0 01-.22.24c-.11.06-.25.06-.53.06h-8.4c-.28 0-.42 0-.53-.05a.5.5 0 01-.22-.22c-.05-.11-.05-.25-.05-.53V2.8c0-.28 0-.42.06-.53.05-.1.14-.18.24-.22.11-.05.24-.04.5-.02a10 10 0 018.44 6.14z"/></svg>`,
};
